var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { red } from '@mui/material/colors';
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.8rem;\n"], ["\n  color: ", ";\n  font-size: 0.8rem;\n"])), red[900]);
var SoldOutTag = function (_a) {
    var children = _a.children;
    return React.createElement(Wrapper, null, children);
};
export default SoldOutTag;
var templateObject_1;
